import React, { Fragment } from 'react'
import {
  SpacerVertical,
  Typography,
  Badge,
  Frame
} from '@klarna/bubble-ui'
import Progress from './Progress'
import styles from './PaymentMethodWithProgress.css'
import config from '../../config'

type PaymentMethodWithProgressProps = {
  badge: string
  backgroundColorKey: string
  frequencySteps: string
  frequencyTitle: string
  purchaseAmount: string
  breakdown: string
  installmentAmount: string
};

const PaymentMethodWithProgress: React.FC<PaymentMethodWithProgressProps> = ({
  badge,
  backgroundColorKey,
  frequencySteps = '',
  frequencyTitle = '',
  breakdown = '',
  installmentAmount = '0'
}) => {
  const progressSteps = {
    3: [33, 66, 100],
    4: [25, 50, 75, 100],
  }
  const steps = frequencySteps.split(',')
  const installments = steps.length
  const breakDownInstallments = breakdown?.split(' - ') || []

  const { badgeColor, badgeTextColor, sibcProgressBackground } = config[backgroundColorKey]
  const progressStepsDefaultBackground = backgroundColorKey === 'darkBackgroundTheme'
    ? 'colors/backgrounds/subtle-inline'
    : 'colors/backgrounds/default'

  return (
    <Fragment>
      <style>{styles}</style>
      <div className="top-info">
        <div>
          <Typography textToken="text-style/headings/blocks/medium/grande">
            {installmentAmount}
          </Typography>
          <SpacerVertical spaceToken="space.none" />
          <Typography textToken="text-style/text/labels/tiny/medium" colorToken="colors/text/neutral">
            {frequencyTitle}
          </Typography>
        </div>

        <div>
          <Badge backgroundColorToken={badgeColor} textColorToken="colors/text/default">
            <Typography textToken="text-style/text/paragraphs/tiny/medium"
              colorToken={badgeTextColor}>
              {badge}
            </Typography>
          </Badge>
        </div>
      </div>

      <div className="progress-steps">
        {progressSteps[installments].map(
          (installment: number, index: number) => (
            <Fragment key={index}>
              <div className='column-flex-container'>
                <Frame backgroundColorToken={index === 0 ? sibcProgressBackground : progressStepsDefaultBackground}>
                  <Progress progress={installment} />
                  <SpacerVertical spaceToken="space.50" />
                  <Typography textToken="text-style/text/paragraphs/tiny/regular" textAlignToken="text-alignment/center">
                    {breakDownInstallments[index]}
                  </Typography>
                  <Typography textToken="text-style/text/labels/micro/regular" textAlignToken="text-alignment/center">
                    {steps[index]}
                  </Typography>
                </Frame>
              </div>
            </Fragment>
          )
        )}
      </div>
    </Fragment>
  )
}

export default PaymentMethodWithProgress
